import type { HTMLAttributes } from 'react';

export function Card({ className, children, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={['rounded-2xl border border-borde bg-white', className].filter(Boolean).join(' ')}
      {...rest}
    >
      {children}
    </div>
  );
}
